import useTimerWrapper from './useTimerWrapper';
import { useUser } from '../redux/reducer/user';
import { calculatePercentageTime } from '../utils/helpers/helpers';

export const useAttemptsCooldown = () => {
  const { attemptsTimer } = useUser();
  const { time } = useTimerWrapper(attemptsTimer);
  return { time, percentageTime: calculatePercentageTime(time) };
};
